export enum MomentFormat {
  datetime = 'YYYY-MM-DD hh:mm a',
  date = 'YYYY-MM-DD'
}